'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  CREATE_PLAYER_INSTANCE: 'CREATE_PLAYER_INSTANCE',
  DESTROY_PLAYER_INSTANCE: 'DESTROY_PLAYER_INSTANCE',
  DISABLE_AUDIO: 'DISABLE_AUDIO',
  INSERT_PLAYABLE: 'INSERT_PLAYABLE',
  REMOVE_PLAYABLE: 'REMOVE_PLAYABLE',
  REORDER_PLAYABLE: 'REORDER_PLAYABLE',
  FAILED_INSERT_PLAYABLE: 'FAILED_INSERT_PLAYABLE',
  FAILED_REMOVE_PLAYABLE: 'FAILED_REMOVE_PLAYABLE',
  SET_AD_BEGAN: 'SET_AD_BEGAN',
  SET_AD_ENDED: 'SET_AD_ENDED',
  SET_AUTO_ADVANCE: 'SET_AUTO_ADVANCE',
  SET_STREAM: 'SET_STREAM',
  SET_STREAM_INTERNAL: 'SET_STREAM_INTERNAL',
  SET_ASPECT_RATIO: 'SET_ASPECT_RATIO',
  SET_AUTO_PLAY: 'SET_AUTO_PLAY',
  SET_CAN_PLAY: 'SET_CAN_PLAY',
  SET_CURRENT_TIME_MS: 'SET_CURRENT_TIME_MS',
  SET_CURRENT_TIME_MS_INTERNAL: 'SET_CURRENT_TIME_MS_INTERNAL',
  SET_DIMENSIONS: 'SET_DIMENSIONS',
  SET_FOCUS: 'SET_FOCUS',
  SET_LOOPING: 'SET_LOOPING',
  SET_MUTE: 'SET_MUTE',
  SET_MUTE_INTERNAL: 'SET_MUTE_INTERNAL',
  SET_PAUSED: 'SET_PAUSED',
  SET_PAUSED_INTERNAL: 'SET_PAUSED_INTERNAL',
  SET_PLAY: 'SET_PLAY',
  SET_PLAY_INTERNAL: 'SET_PLAY_INTERNAL',
  SET_PLAYABLES: 'SET_PLAYABLES',
  SET_PLAYBACK_RATE: 'SET_PLAYBACK_RATE',
  SET_PLAYING_INDEX: 'SET_PLAYING_INDEX',
  SET_PLAYING_INDEX_INTERNAL: 'SET_PLAYING_INDEX_INTERNAL',
  SET_QUALITY: 'SET_QUALITY',
  SET_QUALITY_INTERNAL: 'SET_QUALITY_INTERNAL',
  SET_QUALITIES: 'SET_QUALITIES',
  SET_SEEKING: 'SET_SEEKING',
  SET_VOLUME: 'SET_VOLUME',
  SET_SWITCHING_STREAMS: 'SET_SWITCHING_STREAMS',
  SET_VOLUME_INTERNAL: 'SET_VOLUME_INTERNAL',
  SET_QUEUE_ENDED: 'SET_QUEUE_ENDED',
  TOGGLE_FULLSCREEN: 'TOGGLE_FULLSCREEN',
  TOGGLE_FULLSCREEN_FAILED: 'TOGGLE_FULLSCREEN_FAILED',
  SET_CONTEXT_MENU: 'SET_CONTEXT_MENU',
  SET_DURATION_MS: 'SET_DURATION_MS',
  SET_EXPECTED_DURATION_MS: 'SET_EXPECTED_DURATION_MS',
  SET_LIVE: 'SET_LIVE',
  UPDATE_PLAYABLES: 'UPDATE_PLAYABLES',
  SET_ERROR_INTERNAL: 'SET_ERROR_INTERNAL'
};
module.exports = exports['default'];